<!-- eslint-disable max-len -->
<template>
  <div>
    <report-header
      :download="download"
      :report="report"
      :csv-data="csvData"
    />
    <v-card
      flat
      id="report"
      :loading="loading"
    >
      <report-result-query :query="query" />
      <v-card
        flat
        class="back"
        :loading="loading"
      >
        <div style="display: flex;align-items: center;justify-content: center;margin: 0 auto;text-align: center;flex-direction: row;">
          <report-result-box
            title="TOTAL DE CONSULTAS"
            :result="csvData && csvData.length.toString()"
          >
          </report-result-box>
          <report-result-box
            title="TOTAL DE CONSULTAS POR ACERVO"
            :result="null"
          >
            <p
              style="color: #0399cc;margin-bottom:0"
              v-for="(acervo, x) in porAcervo"
              :key="acervo.titulo"
            >
              {{ x }}: {{ acervo.length }}
            </p>
          </report-result-box>
          <report-result-box
            title="TOTAL DE CONSULTAS POR ÁREA"
            :result="null"
          >
            <p
              style="color: #0399cc;margin-bottom:0"
              v-for="(area, x) in porArea"
              :key="area.titulo"
            >
              {{ x }}: {{ area.length }}
            </p>
          </report-result-box>
        </div>
      </v-card>
      <div style="display: flex;align-items: center;margin: 20px;">
        <table class="tg">
          <tr>
            <th class="tg-0lax">HORÁRIO DA CONSULTA</th>
            <th class="tg-0lax">TÍTULO</th>
            <th class="tg-0lax">ACERVO</th>
            <th class="tg-0lax">ÁREA</th>
          </tr>
          <tr
            v-for="item in csvData"
            :key="item.id"
          >
            <td class="tg-0lax">{{item.horario}}</td>
            <td class="tg-0lax">{{item.titulo}}</td>
            <td class="tg-0lax">{{item.acervo}}</td>
            <td class="tg-0lax">{{item.area}}</td>
          </tr>
        </table>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import reportHeader from '@/components/report-header.vue';
import reportResultBox from '@/components/report-result-box.vue';
import reportResultQuery from '@/components/report-result-query.vue';
import download from '@/mixins/download';

export default {
  components: {
    reportHeader,
    reportResultQuery,
    reportResultBox,
  },
  mixins: [download],
  data() {
    return {
      report: '',
      show: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
      vm.report = 'Consulta';
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    this.report = 'Consulta';
    next();
  },
  computed: {
    ...mapGetters('views/reports/search', [
      'result',
      'query',
      'csvData',
      'loading',
      'porAcervo',
      'porArea',
    ]),
  },
  methods: {
    ...mapActions('views/reports/search', ['afterRouteUpdate']),
  },
};
</script>
<style scoped>
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.tg td {
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #eceff0;
}
.tg th {
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  color: #1e398d;
  border-color: #eceff0;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.back {
  background-color: #fafafa !important;
}
</style>
